import { trim } from 'lodash';
import { useCallback } from 'react';
import { useDebounceState } from '../../core/hooks/useDebounceState';
import { useValueChanges } from '../../core/hooks/useValueChanges';
import { useBulkFilter } from './useBulkFilter';

interface SearchProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  onClear: () => void;
}

export const useBulkSearch = (): SearchProps => {
  const [filter, setFilter] = useBulkFilter();
  const [keyword, keywordDebounced, setKeyword] = useDebounceState(filter.keyword ?? '', trim);

  const handleClearFilter = useCallback(() => {
    setFilter((filter) => ({ pageSize: filter.pageSize, page: 1 }));
  }, [setFilter]);

  const handleSearch = useCallback((keyword?: string) => {
    setFilter((filter) => ({ ...filter, page: 1, keyword }));
  }, [setFilter]);

  useValueChanges(handleSearch, keywordDebounced);

  return {
    searchValue: keyword,
    setSearchValue: setKeyword,
    onClear: handleClearFilter,
  };
};
